<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("vendor", 2) }}
      </div>
      <router-link class="btn-blue" to="vendors">{{ $tc("vendor", 2) }} {{ $tc("list", 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-0" v-if="false">
          <div class="d-flex align-items-center">
            <!-- <div class="dropdown-curve-container">
              <label
                :class="selectedCinema.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('cinema',2) }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
                name="mapcinema"
                id="mapcinema"
              >
                <b-dropdown-item
                  v-for="(cinema, cinemaKey) in Cinemas"
                  :key="cinemaKey"
                  v-on:click="onSelectCinema(cinema.cine_id, cinema.cine_name)"
                >{{ cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>-->
            <multiselect v-model="cinemas" track-by="cine_id" label="cine_name" :options="Cinemas" :multiple="true"
              :disabled="isRoleID" @remove="removeCinema($event)" v-b-tooltip.hover
              :title="$t('vendorMapping_selectCinema')"></multiselect>
            <!-- <Tooltip :title="$t('vendorMapping_selectCinema')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && cinemas.length == 0">Please Select Cinema.</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-0">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input placeholder="." type="text" v-model="vendor_details.v_name" name="vendorname" id="vendorname"
                v-validate="'required'" v-b-tooltip.hover :title="$t('vendorname_tooltip')" />
              <label>{{ $tc("vendor", 2) }} {{ $t("name") }}</label>
            </div>
            <!-- <Tooltip :title="$t('vendorname_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('vendorname')">{{
              errors.first("vendorname")
            }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-2 d-flex mb-2 align-items-center">
          <b-form-checkbox v-model="vendor_details.v_is_active" class="j-checkbox" checked />
          <label class="mb-0">{{ $tc("vendor", 1) }} {{ $t("active") }}</label>
        </div>

        <div class="col-lg-6 col-xl-2 d-flex mb-2 px-0 align-items-center">
          <b-form-checkbox v-model="rmv_is_active" class="j-checkbox" checked />
          <label class="mb-0">{{ $tc("vendor", 1) }} {{ $t("mapping") }}</label>
        </div>

        <div class="col-lg-6 col-xl-2 d-flex mb-2 align-items-center">
          <b-form-checkbox v-model="rmv_is_default_vendor" class="j-checkbox" checked />
          <label class="mb-0">{{ $t("default") }} {{ $tc("vendor", 1) }}</label>
        </div>
      </form>

      <!--Contact Collapse-->
      <div class="section-wrapper col-12 px-0">
        <div class="d-flex">
          <div class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center">
            <div class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="collapseObj.contactDetails = !collapseObj.contactDetails">
              <div class="">{{ $t("contact") }} {{ $tc("details", 2) }}</div>
            </div>
            <span class="icon-collapse-up blue-icon mx-1 btn float-right" style="height: 30px; cursor: pointer"
              v-if="collapseObj.contactDetails"
              @click="collapseObj.contactDetails = !collapseObj.contactDetails"></span>
            <span class="icon-collapse blue-icon mx-1 btn float-right" style="height: 30px; cursor: pointer"
              v-if="!collapseObj.contactDetails"
              @click="collapseObj.contactDetails = !collapseObj.contactDetails"></span>
          </div>
        </div>
        <b-collapse v-model="collapseObj.contactDetails" class="pt-4 px-2 bor mb-4 back collapse show">
          <section class="row">
            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label :class="selected.Country.length > 0 ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("country", 2)
                }}</label>
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <b-dropdown :text="selected.Country" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  href="#"
                  v-for="(country, countryIndex) in Countries"
                  :key="countryIndex"
                  v-on:click="onSelectHandler('country',country)"
                >{{ country.country_name }}</b-dropdown-item>
              </b-dropdown>-->
                  <multiselect :options="Countries" v-model="selected_country" :searchable="true" label="country_name"
                    track-by="country_name" placeholder="Select Country" @input="onSelectHandler('country', $event)"
                    :allowEmpty="false" :showLabels="false" v-b-tooltip.hover :title="$t('vendorsCountry_tooltip')">
                  </multiselect>
                  <!-- <Tooltip :title="$t('vendorsCountry_tooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && selected.Country.length == 0">Please Select Country.</span>
                </p>
              </div>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input placeholder="." type="text" v-model="vendor_details.v_email" name="vendoremail"
                    id="vendoremail" v-validate="'required|email'" v-b-tooltip.hover
                    :title="$t('vendorsEmailId_toolip')" />
                  <label>{{ $t("emailid") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendorsEmailId_toolip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('vendoremail')">{{
                  errors.first("vendoremail")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input placeholder="." type="text" v-model="vendor_details.v_extra_emails" name="vendorextraemail"
                    id="vendorextaemail" :title="$t('vendorsEmailId_toolip')" />
                  <label>{{ $t("extraemailid") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendorsEmailId_toolip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && extraEmailError">{{
                  "Please enter a valid email"
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material row align-items-center">
                  <div class="col-4">
                    <b-dropdown :text="vendor_details.country_mob_code
                      ? vendor_details.country_mob_code
                      : 'Code'
                      " variant="dropdown-curve" class="w-100 text-center mr-3" placeholder="code" name="countrycode"
                      id="countrycode">
                      <div class="px-2 pb-2">
                        <input required autofocus type="search" placeholder="Search Code"
                          class="form-control form-control-sm" v-model="searchCode" />
                      </div>
                      <b-dropdown-item href="#" v-for="(
countrycode, countryIndex
                        ) in countryCodeComputed" :key="countryIndex"
                        v-on:click="onSelectHandler('countrycode', countrycode)"
                        v-if="countrycode.country_mob_code != null">{{ countrycode.country_mob_code }}</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <div class="col-xl-8 d-flex">
                    <div class="col-11 pl-1">
                      <input placeholder="." type="text" v-model="vendor_details.v_contact" name="vendorno"
                        id="vendorno" v-validate="'required|numeric|min:6|max:10'" v-b-tooltip.hover
                        :title="$t('vendorsContactNumber_tooltip')" />
                      <label>{{ $t("contactno") }}</label>
                    </div>
                    <div class="col-1">
                      <button class="btn-transparent" @click.prevent.stop="add_extra_contact()">
                        <img src="@/assets/img/icons/plus.svg" height="30" width="30" />
                      </button>
                    </div>
                  </div>
                </div>
                <!-- <Tooltip :title="$t('vendorsContactNumber_tooltip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && !vendor_details.country_mob_code">{{
                  "Country Code is Required."
                }}</span>
                <span>{{ " " }}</span>
                <span v-if="submitted && errors.has('vendorno')"><span v-if="submitted && errors.has('vendorno')">Vendor
                    no should be numeric with min. 6 and max. 10
                    numbers</span></span>
              </p>
            </div>

            <div v-if="v_extra_contacts.length" v-for="(contact, contactIndex) in v_extra_contacts" :key="contactIndex"
              class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material row align-items-center">
                  <div class="col-4">
                    <b-dropdown :text="contact.country_mob_code
                      ? contact.country_mob_code
                      : 'Code'
                      " variant="dropdown-curve" class="w-100 text-center mr-3" placeholder="code"
                      :name="'countrycode' + contactIndex" :id="'countrycode' + contactIndex">
                      <div class="px-2 pb-2">
                        <input required type="search" placeholder="Search Code" class="form-control form-control-sm"
                          v-model="searchCode" />
                      </div>
                      <b-dropdown-item href="#" v-for="(
countrycode, countryIndex
                        ) in countryCodeComputed" :key="countryIndex" v-on:click="
                          contact.country_mob_code =
                          countrycode.country_mob_code
                          " v-if="countrycode.country_mob_code != null">{{ countrycode.country_mob_code
                          }}</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <div class="col-8 d-flex">
                    <div class="col-11 pl-1">
                      <input placeholder="." type="text" v-model.number="contact.v_contact" name="vendorno"
                        id="vendorno" :title="$t('vendorsContactNumber_tooltip')" />
                      <label>{{ $t("contactno") }}</label>
                    </div>

                    <div class="col-1">
                      <button class="btn-transparent" @click.prevent.stop="remove_extra_contact(contactIndex)">
                        <img src="@/assets/img/icons/minus.svg" height="30" width="30" />
                      </button>
                    </div>
                  </div>
                </div>
                <!-- <Tooltip :title="$t('vendorsContactNumber_tooltip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && contact.error">{{
                  contact.error_message || "Contact Number is invalid"
                }}</span>
              </p>
            </div>
            <div v-if="v_extra_contacts.length" class="col-12"></div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input placeholder="." type="text" v-model="vendor_details.v_address" name="vendoraddress"
                    id="vendoraddress" v-validate="'required|max:255'" v-b-tooltip.hover
                    :title="$t('vendor_address')" />
                  <label>{{ $t("address") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_address')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('vendoraddress')">{{
                  errors.first("vendoraddress")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input placeholder="." type="text" v-validate="'max:255'" v-model="vendor_details.v_location"
                    name="vendorlocation" id="vendorlocation" v-b-tooltip.hover :title="$t('vendor_location')" />
                  <label>{{ $t("location") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_location')" /> -->
              </div>
              <!-- <p class="error_message">{{ $t('blankfieldmsg') }}</p> -->
              <p class="error_message">
                <span v-if="submitted && errors.has('vendorlocation')">Vendor location may not be greater than 255
                  characters</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label :class="selected.State.length > 0 ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("state", 2)
                }}</label>
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <b-dropdown :text="selected.State" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(state,stateIndex) in States"
                  :key="stateIndex"
                  href="#"
                  @click="onSelectHandler('state',state)"
                >{{ state.state_name }}</b-dropdown-item>
              </b-dropdown>-->
                  <multiselect v-validate="'required'" :options="States" v-model="selected_state" :searchable="true"
                    label="state_name" track-by="state_name" placeholder="Select State" :allowEmpty="false"
                    :showLabels="false" @input="onSelectHandler('state', $event)" v-b-tooltip.hover
                    :title="$t('vendorStates_tooltip')">
                  </multiselect>
                  <!-- <Tooltip :title="$t('vendorStates_tooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && selected.State.length == 0">Please Select State.</span>
                </p>
              </div>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-1">
              <div class="dropdown-curve-container">
                <label :class="selected.City.length > 0 ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("city", 1)
                }}</label>
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <b-dropdown :text="selected.City" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(city,cityIndex) in Cities"
                  :key="cityIndex"
                  href="#"
                  @click="onSelectHandler('city',city)"
                >{{ city.city_name }}</b-dropdown-item>
              </b-dropdown>-->
                  <multiselect v-validate="'required'" :options="Cities" v-model="selected_city" :searchable="true"
                    label="city_name" track-by="city_name" placeholder="Select City" :allowEmpty="false"
                    :showLabels="false" @input="onSelectHandler('city', $event)" v-b-tooltip.hover
                    :title="$t('vendorCity_tooltip')">
                  </multiselect>
                  <!-- <Tooltip :title="$t('vendorCity_tooltip')" /> -->
                </div>
                <p class="error_message">
                  <span v-if="submitted && selected.City.length == 0">Please Select City.</span>
                </p>
              </div>
            </div>
          </section>
        </b-collapse>
      </div>
      <!--Contact Collapse End-->

      <!--Tax Collapse-->
      <div class="section-wrapper col-12 px-0">
        <div class="d-flex">
          <div class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center">
            <div class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="collapseObj.taxDetails = !collapseObj.taxDetails">
              <div class="">{{ $t("tax") }} {{ $tc("details", 2) }}</div>
            </div>
            <span class="icon-collapse-up blue-icon mx-1 btn float-right" style="height: 30px; cursor: pointer"
              v-if="collapseObj.taxDetails" @click="collapseObj.taxDetails = !collapseObj.taxDetails"></span>
            <span class="icon-collapse blue-icon mx-1 btn float-right" style="height: 30px; cursor: pointer"
              v-if="!collapseObj.taxDetails" @click="collapseObj.taxDetails = !collapseObj.taxDetails"></span>
          </div>
        </div>
        <b-collapse v-model="collapseObj.taxDetails" class="pt-4 px-2 bor mb-4 back collapse show">
          <section class="row">
            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input placeholder="." type="text" v-model="vendor_details.v_tin_number" name="vendornumber"
                    id="vendornumber" v-validate="'alpha_num|min:3|max:11'" v-b-tooltip.hover
                    :title="$t('vendor_TinNumber')" />
                  <label>{{ $tc("vendor", 2) }} {{ $t("tinnumber") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_TinNumber')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('vendornumber')">{{
                  errors.first("vendornumber")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input placeholder="." type="text" v-model="vendor_details.v_tax_number" name="vendortax"
                    id="vendortax" v-validate="'alpha_num|min:3|max:15'" v-b-tooltip.hover
                    :title="$t('vendor_TaxNumber')" />
                  <label>{{ $tc("vendor", 2) }} {{ $t("taxnumber") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_TaxNumber')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('vendortax')">{{
                  errors.first("vendortax")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input placeholder="." type="text" v-model="vendor_details.v_tax_type" name="taxtype" id="taxtype"
                    v-validate="'regex:[A-Za-z0-9 ]|max:255'" v-b-tooltip.hover :title="$t('vendor_TaxType')" />
                  <label>{{ $tc("vendor", 2) }} {{ $t("taxtype") }}</label>
                </div>
                <!-- <Tooltip :title="$t('vendor_TaxType')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('taxtype')">Tax type may not be greater than 255 characters</span>
              </p>
            </div>
          </section>
        </b-collapse>
      </div>

      <!--Tax Collapse Ends-->

      <!---Vendor Rate--->
      <div class="section-wrapper col-12 px-0">
        <div class="d-flex">
          <div class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center">
            <div class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="collapseObj.vendorRate = !collapseObj.vendorRate">
              <div class="">{{ $tc("vendor", 1) }} {{ $t("rate") }}</div>
            </div>
            <span class="icon-collapse-up blue-icon mx-1 btn float-right" style="height: 30px; cursor: pointer"
              v-if="collapseObj.vendorRate" @click="collapseObj.vendorRate = !collapseObj.vendorRate"></span>
            <span class="icon-collapse blue-icon mx-1 btn float-right" style="height: 30px; cursor: pointer"
              v-if="!collapseObj.vendorRate" @click="collapseObj.vendorRate = !collapseObj.vendorRate"></span>
          </div>
        </div>
        <b-collapse v-model="collapseObj.vendorRate" class="pt-3 px-2 bor mb-4 back collapse show">
          <div class="d-flex justify-content-between mb-1">
            <div class="d-flex justify-content-start">
              <div class="row">
                <div class="col-6">
                  <multiselect v-model="vendor_filters.selectedCinema" :placeholder="'Cinema'" :options="Cinemas"
                    @select="onSelectCinemaFilter($event, 'select')" @remove="onSelectCinemaFilter($event, 'remove')"
                    selectLabel="Select" deselectLabel="✖" label="cine_name" track-by="cine_id" :multiple="false">
                  </multiselect>
                </div>
                <div class="col-6">
                  <div>
                    <b-form-input v-model="vendor_filters.searchValue" v-debounce:800="onSearchVendorMapping"
                      placeholder="Search..." :style="'border-radius: 10px'"></b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <div style="">
                <b-pagination v-model="vendor_filters.currentPage" :total-rows="vendor_filters.rows"
                  @change="onChangePagination($event)" :per-page="vendor_filters.perPage" aria-controls="my-table" />
              </div>

              <div>
                <b-button variant="default" @click="onClickAddVendorMapping" class="btn-blue">{{ $t("add") }}</b-button>
              </div>
            </div>
          </div>

          <section class="row">
            <div class="table-scroll w-100 mx-3 mb-3">
              <table class="swc-report-table" border="1">
                <thead>
                  <tr>
                    <th class="bg-lightgrey p-1">Cinema</th>
                    <th class="bg-lightgrey p-1">Raw Material</th>
                    <th class="bg-lightgrey p-1">QTY</th>
                    <th class="bg-lightgrey p-1">UOM</th>
                    <th class="bg-lightgrey p-1">Rate</th>
                    <th class="bg-lightgrey p-1">Tax %</th>
                    <th class="bg-lightgrey p-1">Total</th>
                    <th class="bg-lightgrey p-1">Rate Created at</th>
                    <th class="bg-lightgrey p-1">Action</th>
                  </tr>
                </thead>
                <tbody v-if="selectedRawMaterials.length > 0">
                  <tr v-for="(list, listKey) in selectedRawMaterials" :key="listKey"
                    :class="checkInactive(list) ? 'strikeout' : ''">
                    <td class="text-left">{{ list.cinema_name || "-" }}</td>
                    <td class="text-left">{{ list.name || "-" }}</td>
                    <td class="text-right">{{ list.vr_qty || "0" }}</td>
                    <td class="text-left">{{ list.uom_unit || "-" }}</td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_rate).toFixed(4) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_tax_amount_percentage).toFixed(4) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_total_amount).toFixed(4) }}
                    </td>
                    <td class="text-left">{{ list.created_at | dateparse }}</td>
                    <td>
                      <div class="edit-pen blue-icon ml-2 btn" @click="OnEditVendorMapping(list, listKey)"></div>
                      <div class="icon-sm-minus blue-icon ml-2 btn" @click="inActiveVendorMapping(list, listKey)"></div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="9">
                      <NoRecords />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </b-collapse>
        <b-collapse class="pt-3 px-2 bor mb-4 back collapse show">
          <section class="row">
            <div class="col">
              <div class="d-flex justify-content-center mb-2">
                <div class="d-flex justify-content-center mb-2">
                  <button class="btn-transparent" @click.prevent.stop="increaseRow()">
                    <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                  </button>
                </div>
              </div>
            </div>

            <div class="col-12" v-if="submitted && isValidationError">
              <p class="error_message fs-14">
                <span v-if="submitted && isValidationError">{{
                  $t("please_enter_all_details")
                }}</span>
              </p>
            </div>
          </section>
        </b-collapse>
      </div>

      <div class="section-wrapper col-12 px-0" v-if="
        finalAddVendorMappingArray.length > 0 ||
        finalEditVendorMappingArray.length > 0
      ">
        <div class="d-flex">
          <div class="sectionName bor d-flex justify-content-between mb-2 col-12 align-items-center">
            <div class="fs-17 font-weight-bold pl-2 align-items-center"
              @click="collapseObj.vendorReview = !collapseObj.vendorReview">
              <div class="">Vendor Mapping Price Review</div>
            </div>
            <span class="icon-collapse-up blue-icon mx-1 btn float-right" style="height: 30px; cursor: pointer"
              v-if="collapseObj.vendorReview" @click="collapseObj.vendorReview = !collapseObj.vendorReview"></span>
            <span class="icon-collapse blue-icon mx-1 btn float-right" style="height: 30px; cursor: pointer"
              v-if="!collapseObj.vendorReview" @click="collapseObj.vendorReview = !collapseObj.vendorReview"></span>
          </div>
        </div>
        <b-collapse v-model="collapseObj.vendorReview" class="pt-3 px-2 bor mb-4 back collapse show">
          <section class="row">
            <div class="table-scroll w-100 mx-3 mb-3" v-if="finalAddVendorMappingArray.length > 0">
              <label class="font-weight-bold">Add Review</label>
              <table class="swc-report-table" border="1">
                <thead>
                  <tr>
                    <th class="bg-lightgrey p-1">Cinema</th>
                    <th class="bg-lightgrey p-1">Raw Material</th>
                    <th class="bg-lightgrey p-1">QTY</th>
                    <th class="bg-lightgrey p-1">UOM</th>
                    <th class="bg-lightgrey p-1">Rate</th>
                    <th class="bg-lightgrey p-1">Tax %</th>
                    <th class="bg-lightgrey p-1">Total</th>
                    <th class="bg-lightgrey p-1">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, listKey) in finalAddVendorMappingArray" :key="listKey">
                    <td class="text-left">{{ list.cinema_name || "-" }}</td>
                    <td class="text-left">{{ list.name || "-" }}</td>
                    <td class="text-right">{{ list.vr_qty || "0" }}</td>
                    <td class="text-left">{{ list.uom_unit || "-" }}</td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_rate).toFixed(4) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_tax_amount_percentage).toFixed(4) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_total_amount).toFixed(4) }}
                    </td>
                    <td>
                      <div class="icon-delete-red blue-icon ml-2 btn" @click="
                        onRemoveFinalVendorPricing(list, listKey, 'Add')
                        "></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-scroll w-100 mx-3 mb-3" v-if="finalEditVendorMappingArray.length > 0">
              <label class="font-weight-bold">Edit Review</label>
              <table class="swc-report-table" border="1">
                <thead>
                  <tr>
                    <th class="bg-lightgrey p-1">Cinema</th>
                    <th class="bg-lightgrey p-1">Raw Material</th>
                    <th class="bg-lightgrey p-1">QTY</th>
                    <th class="bg-lightgrey p-1">UOM</th>
                    <th class="bg-lightgrey p-1">Rate</th>
                    <th class="bg-lightgrey p-1">Tax %</th>
                    <th class="bg-lightgrey p-1">Total</th>
                    <th class="bg-lightgrey p-1">Status</th>
                    <th class="bg-lightgrey p-1">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, listKey) in finalEditVendorMappingArray" :key="listKey">
                    <td class="text-left">{{ list.cinema_name || "-" }}</td>
                    <td class="text-left">{{ list.name || "-" }}</td>
                    <td class="text-right">{{ list.vr_qty || "0" }}</td>
                    <td class="text-left">{{ list.uom_unit || "-" }}</td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_rate).toFixed(4) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_tax_amount_percentage).toFixed(4) }}
                    </td>
                    <td class="text-right">
                      {{ parseFloat(list.vr_total_amount).toFixed(4) }}
                    </td>
                    <td class="text-left">{{ list.is_active || "Y" }}</td>
                    <td>
                      <div class="icon-delete-red blue-icon ml-2 btn" @click="
                        onRemoveFinalVendorPricing(list, listKey, 'Edit')
                        "></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </b-collapse>
      </div>

      <!---Vendor Rate Ends--->

      <div class="col-md-12 mb-2"></div>

      <!-- FOR RAW MATERIALS FROM VENDOR MAPPING -->

      <div class="col-md-12 text-center mt-4">
        <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">
          {{ $t("update") }}
        </button>
        <!-- <button @click.prevent.stop="onResetForm()" class="btn-black">
          {{ $t("reset") }}
        </button> -->
        <b-button class="btn-outline-grey" variant="default" to="vendors">{{
          $t("cancel")
        }}</b-button>
      </div>
    </div>
    <b-modal id="editRawMaterialVendorPrice" ref="editRawMaterialVendorPrice" :title="'Update Vendor Price'" hide-footer
      size="lg" show>
      <div class="">
        <section class="row" :style="'zoom: 0.9;max-height:520px;overflow-y:auto;'">
          <div class="col-md-12">
            <div class="row mb-3 mx-2">
              <div class="col-md-12 inner-vendor-rate">
                <div class="row p-2">
                  <div class="col-xl-6 align-self-center mb-2">
                    <div class="input-material">
                      <input v-model="selected_vm.cinema_name" type="text" disabled name="cinema_name" id="cinema_name"
                        placeholder="." />
                      <label>Cinema</label>
                    </div>
                    <p class="error_message"></p>
                  </div>
                  <div class="col-xl-6 align-self-center mb-2">
                    <multiselect :options="RawMaterials" v-model="selected_vm.selectedRawMaterial" :searchable="true"
                      label="rm_name" track-by="rm_id" placeholder="Select Raw Material" :showLabels="false" disabled
                      @select="onSelectRawMaterial_vm($event)"></multiselect>
                    <p class="error_message">
                      <span v-if="
                        submitted &&
                        selected_vm.selectedRawMaterial.length == 0
                      ">Please Select Raw Material.</span>
                    </p>
                  </div>
                  <div class="col-md-3 mb-2">
                    <div class="input-material">
                      <input v-model="selected_vm.vr_qty" type="number" name="mapquantity" id="mapquantity"
                        placeholder="." />
                      <label>{{ $t("quantity") }}</label>
                    </div>
                    <p class="error_message"></p>
                  </div>
                  <div class="col-md-3 mb-2">
                    <div class="dropdown-curve-container">
                      <label :class="selected_vm.uom_unit.length > 0 ? 'shift-up' : ''
                        ">UOM</label>
                      <b-dropdown :text="selected_vm.uom_unit" variant="dropdown-curve" class="w-100">
                        <b-dropdown-item v-for="(uom, uomKey) in selected_vm.uom_units" :key="uomKey"
                          v-on:click="onSelectUnitOfM_vm(uom)">{{ uom.uom_unit }}</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <p class="error_message"></p>
                  </div>
                  <div class="col-md-3 mb-2">
                    <div class="input-material">
                      <input v-model="selected_vm.vr_rate" type="number" v-on:keyup="onChangeRate($event, null, 'Edit')"
                        name="rate" id="rate" placeholder="." />
                      <label>{{ $t("rate") }}</label>
                    </div>
                    <p class="error_message"></p>
                  </div>
                  <div class="col-md-3 mb-2">
                    <div class="input-material">
                      <input v-model="selected_vm.vr_tax_amount_percentage" type="number"
                        v-on:keyup="onChangeTaxPercentage($event, null, 'Edit')" name="tax" id="tax" placeholder="." />
                      <label>{{ $t("Tax In %") }}</label>
                    </div>
                    <p class="error_message"></p>
                  </div>
                  <div class="col-md-3 mb-2">
                    <div class="input-material">
                      <input v-model="selected_vm.vr_tax_amount" type="number"
                        v-on:keyup="onChangeTax($event, null, 'Edit')" name="tax" id="tax" disabled placeholder="." />
                      <label>{{ $t("Tax Amount") }}</label>
                    </div>
                    <p class="error_message"></p>
                  </div>
                  <div class="col-md-3 mb-2">
                    <div class="input-material">
                      <input v-model="selected_vm.vr_total_amount" type="number" name="Total Amount" id="Total Amount"
                        disabled placeholder="." v-validate="'required|decimal'" />
                      <label>{{ $t("totalamount") }}</label>
                    </div>
                    <p class="error_message"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-center mt-4">
            <button @click.prevent.stop="onUpdateVendorMapping()" class="btn-blue">
              {{ $t("save") }}
            </button>
            <b-button class="btn-outline-grey" variant="default" @click="$bvModal.hide('editRawMaterialVendorPrice')">{{
              $t("cancel") }}</b-button>
          </div>
        </section>
      </div>
    </b-modal>

    <b-modal id="AddVendorMapping" ref="AddVendorMapping" :title="'Add Vendor Price'" hide-footer size="lg" show>
      <div class="">
        <section class="row" :style="'zoom: 0.9;max-height:520px;overflow-y:auto;'">
          <div v-for="(list, listKey) in newVendorRateMapping" :key="listKey" class="col-md-12">
            <div class="row mb-3 mx-2">
              <div class="col-md-11 inner-vendor-rate">
                <div class="row pt-3">
                  <div class="col-md-6 mb-3">
                    <multiselect :options="Cinemas" v-model="list.selectedCinema" :searchable="true" label="cine_name"
                      track-by="cine_id" placeholder="Select Cinemas" :multiple="true"></multiselect>
                  </div>

                  <div class="col-md-6 mb-3">
                    <multiselect :options="RawMaterials" v-model="list.selectedRawMaterial" :searchable="true"
                      @select="onSelectRawMaterial($event, listKey, 'Add')" label="rm_name" track-by="rm_id"
                      placeholder="Select Raw Material" :allowEmpty="false" :showLabels="false"></multiselect>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input v-model="list.vr_qty" type="number" name="mapquantity" id="mapquantity" placeholder="." />
                      <label>{{ $t("quantity") }}</label>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="dropdown-curve-container">
                      <label :class="list.uom_unit.length > 0 ? 'shift-up' : ''">UOM</label>
                      <b-dropdown :text="list.uom_unit" variant="dropdown-curve" class="w-100">
                        <b-dropdown-item v-for="(uom, uomKey) in list.uom_units" :key="uomKey"
                          v-on:click="onSelectUnitOfM(uom, listKey, 'Add')">{{ uom.uom_unit }}</b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input v-model="list.vr_rate" type="number" v-on:keyup="onChangeRate($event, listKey, 'Add')"
                        name="rate" id="rate" placeholder="." />
                      <label>{{ $t("rate") }}</label>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input v-model="list.vr_tax_amount_percentage" type="number" v-on:keyup="
                        onChangeTaxPercentage($event, listKey, 'Add')
                        " name="tax" id="tax" placeholder="." />
                      <label>{{ $t("Tax In %") }}</label>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input v-model="list.vr_tax_amount" type="number" v-on:keyup="onChangeTax($event, listKey, 'Add')"
                        name="tax" id="tax" disabled placeholder="." />
                      <label>{{ $t("Tax Amount") }}</label>
                    </div>
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="input-material">
                      <input v-model="list.vr_total_amount" type="number" name="Total Amount" id="Total Amount" disabled
                        placeholder="." v-validate="'required|decimal'" />
                      <label>{{ $t("totalamount") }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-1 d-flex justify-content-center mb-2">
                <button class="btn-transparent" v-if="listKey === 0 && false"
                  @click.prevent.stop="increaseRow_add_vm()">
                  <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                </button>
                <button :disabled="listKey === 0" @click.prevent.stop="decreaseRow_remove_vm(listKey)"
                  class="btn-transparent">
                  <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                </button>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex justify-content-center mb-2">
              <div class="d-flex justify-content-center mb-2">
                <button class="btn-transparent" @click.prevent.stop="increaseRow_add_vm()">
                  <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                </button>
              </div>
            </div>
          </div>

          <div class="col-12" v-if="submitted && isValidationError">
            <p class="error_message fs-14">
              <span v-if="submitted && isValidationError">{{
                $t("please_enter_all_details")
              }}</span>
            </p>
          </div>
        </section>
        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onSaveAddNewVendorMapping()" class="btn-blue">
            {{ $t("Save") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" @click="onClickCancelAddVedorMapping()">{{ $t("cancel")
          }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import Multiselect from "vue-multiselect";
import { removeDuplicates } from "@/helper/collection";
import _ from "lodash";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { getCinemaBaseURL } from "@/services/Api";


const selected = {};
export default {
  components: { Multiselect, NoRecords },
  data() {
    return {
      finalAddVendorMappingArray: [],
      finalEditVendorMappingArray: [],
      newVendorRateMapping: [],
      newObj: {
        cinema_id: null,
        selectedCinema: [],
        cinemaIds: [],
        name: "",
        rm_id: "",
        vr_qty: "",
        uom_id: "",
        uom_unit: "",
        vr_rate: null,
        selectedRawMaterial: "",
        vr_tax_amount: 0,
        vr_tax_amount_percentage: 0,
        vr_total_amount: null,
        vr_is_active: true,
        uom_units: [],
      },
      vendor_filters: {
        selectedCinema: "",
        cinema_id: null,
        perPage: 10,
        currentPage: 1,
        searchValue: null,
        orderBy: null,
        columnName: null,
        rows: 0,
        selectedvalue: "10",
      },
      selected_vm: {
        name: "",
        rm_id: "",
        vr_qty: "",
        uom_id: "",
        uom_unit: "",
        vr_rate: null,
        selectedRawMaterial: "",
        vr_tax_amount: 0,
        vr_tax_amount_percentage: 0,
        vr_total_amount: null,
        vr_is_active: true,
        uom_units: [],
      },
      v_extra_contacts: [],
      collapseObj: {
        contactDetails: true,
        taxDetails: true,
        vendorRate: true,
        vendorReview: true,
      },
      removedRawMaterials: [],
      selected_country: null,
      selected_state: null,
      selected_city: null,
      isRoleID: true,
      cinemas: [],
      submitted: false,
      selected: null,
      options: ["Kg", "Gms", "Lt", "Pks", "Ps"],
      vendor_details: {
        v_name: "",
        v_tin_number: "",
        v_tax_number: "",
        v_tax_type: "",
        v_address: "",
        city_id: "",
        state_id: "",
        country_id: "",
        country_mob_code: "",
        v_contact: "",
        v_email: "",
        v_extra_emails: "",
        v_location: "",
        v_is_active: true,
        v_id: "",
      },
      extraEmailError: false,
      Countries: [],
      selectedCinema: "",
      States: [],
      Cinemas: [],
      Cities: [],
      selected: {
        Country: "Select Country",
        State: "Select State",
        City: "Select City",
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },

      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states",
      },

      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities",
      },
      searchRawMaterial: "",
      //Vendor mapping
      rmv_id: "",
      rmv_is_active: true,
      rmv_is_default_vendor: true,
      cinema_id: "",
      vendor_id: "",
      UomList: [],
      RawMaterials: [],
      RawMaterialsCopy: [],
      selectedRawMaterials: [
        {
          name: "",
          rm_id: "",
          vr_qty: "",
          vr_tax_amount: 0,
          vr_tax_amount_percentage: 0,
          vr_total_amount: "",
          selectedRawMaterial: "",
          uom_id: "",
          uom_unit: "",
          vr_rate: "",
          vr_is_active: true,
          uom_units: [],
        },
      ],
      removedCinemas: [],
      searchCode: "",
      CodeListCopy: [],
      countryList: [],
      SelectedCountryCode: "",
      isValidationError: false,
      filteredVendors:[]
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.vendor_filters.cinema_id = obj
    this.getCinemasList(obj);
    this.vendor_details.v_id = this.$route.query.v_id;
    this.vendor_id = this.$route.query.v_id;
  },
  async mounted() {
    this.getVendorDetails();
    await this.getunitsofmeasurements();
    await this.getRawMaterials();
    this.getVendorsList()
  },
  computed: {
    countryCodeComputed() {
      let search = String(this.searchCode || "");
      let countryList = this.CodeListCopy;

      // if (search.length) {
      //   countryList = this.CodeListCopy.filter((x) => {
      //     if (
      //       x.country_mob_code &&
      //       x.country_mob_code
      //         .toLowerCase()
      //         .includes(String(search).toLowerCase())
      //     ) {
      //       return x;
      //     }
      //   });
      // }

      // return countryList;

      if (search.length) {
        countryList = this.CodeListCopy.filter((x) => {
          return (
            x.country_mob_code &&
            x.country_mob_code.toLowerCase().includes(search)
          );
        });
      }

      const uniqueList = [];
      const seenCodes = new Set();

      for (const item of countryList) {
        const code = item.country_mob_code;
        if (code && !seenCodes.has(code)) {
          seenCodes.add(code);
          uniqueList.push(item);
        }
      }

      const specialCode = "20";
      const specialItem = uniqueList.find(
        (x) => x.country_mob_code === specialCode
      );

      const otherItems = uniqueList
        .filter((x) => x.country_mob_code && x.country_mob_code !== specialCode)
        .sort((a, b) => {
          return parseInt(a.country_mob_code) - parseInt(b.country_mob_code);
        });

      return specialItem ? [specialItem, ...otherItems] : otherItems;
    },
  },
  methods: {
     getVendorsList() {
          PosFnbService.GetVendorListNew()
            .then((response) => {
              const { data } = response;
              if (data && data.status && data.Records.length > 0) {
                this.vendor_details.v_id = this.$route.query.v_id;
                console.log("this.vendor_details.v_id",this.vendor_details.v_id)
                 this.filteredVendors = data.Records.filter((el) => {
                   return el.v_id != this.vendor_details.v_id;
                  });
                console.log("this.vendorsss",this.filteredVendors)
              }
            })
            .catch((error) => {
              this.$toasted.show(error);
            });
        },
    VendorMappingValidation: function (arr = [], showErrorMsg = true) {
      let count = 0;
      let ErrorMsg = ``;
      let ErrorIndex = null;
      console.log("arr", arr);
      if (arr.length > 0) {
        arr.map((x, index) => {
          if (!x.rm_id || x.rm_id == null) {
            count++;
            (ErrorMsg = `Please Select Raw Material`), (ErrorIndex = index);
          } else if (x.uom_id == null || !x.uom_id) {
            count++;
            (ErrorMsg = `Please Select Unit Of Measurement`),
              (ErrorIndex = index);
          } else if (!x.cinema_id || x.cinema_id == null) {
            count++;
            (ErrorMsg = `Please Select Cinema`), (ErrorIndex = index);
          } else if (!x.vr_qty || x.vr_qty == null) {
            count++;
            (ErrorMsg = `Please Select Quantity`), (ErrorIndex = index);
          } else if (!x.vr_rate || x.vr_rate == null) {
            count++;
            (ErrorMsg = `Please Enter Rate`), (ErrorIndex = index);
          }
        });
      }

      if (count > 0) {
        if (showErrorMsg) {
          this.$toasted.show(ErrorMsg);
        }
        return false;
      } else {
        return true;
      }
    },
    checkInactive(vm) {
      return this.finalEditVendorMappingArray.some(
        (x) => x.vr_id == vm.vr_id && x.is_active == "N"
      );
    },
    inActiveVendorMapping(vm, vmIndex) {
      let newObj = {
        ...vm,
        is_active: "N",
      };
      let checkIndex = this.finalEditVendorMappingArray.findIndex(
        (x) => x.vr_id == vm.vr_id
      );
      if (checkIndex > -1) {
        this.finalEditVendorMappingArray[checkIndex] = _.cloneDeep(newObj);
      } else {
        this.finalEditVendorMappingArray.push(newObj);
      }
      this.$forceUpdate();
    },
    onRemoveFinalVendorPricing(vm, vmIndex, type) {
      if (type == "Add") {
        this.finalAddVendorMappingArray.splice(vmIndex, 1);
      } else {
        this.finalEditVendorMappingArray.splice(vmIndex, 1);
      }
    },
    onSaveAddNewVendorMapping() {
      console.log("this.newVendorRateMapping", this.newVendorRateMapping);
      let tempArray = [];
      this.newVendorRateMapping.forEach((x) => {
        x.selectedCinema.forEach((y) => {
          let newObj = {
            ...x,
            cinema_id: y.cine_id,
            cinema_name: y.cine_name,
          };
          tempArray.push(newObj);
        });
      });
      if (this.VendorMappingValidation(tempArray)) {
        this.finalAddVendorMappingArray =
          this.finalAddVendorMappingArray.concat(tempArray);
        this.newVendorRateMapping = [];
        this.$bvModal.hide("AddVendorMapping");
        console.log(
          "this.finalAddVendorMappingArray",
          this.finalAddVendorMappingArray
        );
      } else {
        console.log("COMING IN ELSE");
      }
    },
    onClickCancelAddVedorMapping() {
      this.newVendorRateMapping = [];
      this.$bvModal.hide("AddVendorMapping");
    },
    onUpdateVendorMapping() {
      if (this.VendorMappingValidation([this.selected_vm])) {
        let checkIndex = this.finalEditVendorMappingArray.findIndex(
          (x) =>
            x.cinema_id == this.selected_vm.cinema_id &&
            x.rm_id == this.selected_vm.rm_id
        );
        if (checkIndex > -1) {
          this.finalEditVendorMappingArray[checkIndex] = _.cloneDeep(
            this.selected_vm
          );
        } else {
          this.finalEditVendorMappingArray.push(this.selected_vm);
        }
        console.log(
          "this.finalEditVendorMappingArray",
          this.finalEditVendorMappingArray
        );
        this.$bvModal.hide("editRawMaterialVendorPrice");
      }
    },
    onSelectUnitOfM_vm() { },
    OnEditVendorMapping(list) {
      this.selected_vm = _.cloneDeep(list);
      this.$bvModal.show("editRawMaterialVendorPrice");
    },
    onClickAddVendorMapping() {
      this.newVendorRateMapping = [];
      let newObj = {
        cinema_id: null,
        selectedCinema: [],
        cinemaIds: [],
        name: "",
        rm_id: "",
        vr_qty: "",
        uom_id: "",
        uom_unit: "",
        vr_rate: null,
        selectedRawMaterial: "",
        vr_tax_amount: 0,
        vr_tax_amount_percentage: 0,
        vr_total_amount: null,
        vr_is_active: true,
        uom_units: [],
      };
      if (this.newVendorRateMapping.length == 0) {
        this.newVendorRateMapping.push(newObj);
      }
      this.$bvModal.show("AddVendorMapping");
    },
    onChangePagination(event) {
      if (event === undefined) {
        this.vendor_filters.currentPage = 1;
        this.getMappingDetails();
      } else {
        this.vendor_filters.currentPage = event;
        this.getMappingDetails();
      }
    },
    onSelectCinemaFilter(cinema, type) {
      if (type == "select") {
        this.vendor_filters.cinema_id = cinema.cine_id;
      } else {
        this.vendor_filters.cinema_id = null;
      }
      this.currentPage = 1;
      this.getMappingDetails();
    },
    onSearchVendorMapping() {
      this.currentPage = 1;
      this.getMappingDetails();
    },
    add_extra_contact() {
      let extra_contact = {
        country_mob_code: "",
        v_contact: "",
        error: false,
        error_message: "",
      };
      this.v_extra_contacts.push(extra_contact);
    },
    remove_extra_contact(index) {
      if (
        index == null ||
        index == undefined ||
        this.v_extra_contacts.length <= 0
      )
        return;

      this.v_extra_contacts = this.v_extra_contacts.filter(
        (_, i) => i != index
      );
    },
    removeCinema(removedOption) {
      if (removedOption.rmv_id) {
        this.removedCinemas.push(removedOption);
      }
      console.log("this.removedCinemas :>> ", this.removedCinemas);
    },
    onSearchRawMaterial: function (value) {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.RawMaterials = this.RawMaterialsCopy.filter((x) => {
          if (
            x.rm_name
              .toLowerCase()
              .includes(this.searchRawMaterial.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.RawMaterials = this.RawMaterialsCopy;
      }
    },
    //Vendor Mapping
    decreaseRow: function (index) {
      if (this.selectedRawMaterials[index].vr_id) {
        this.removedRawMaterials.push(this.selectedRawMaterials[index]);
      }
      this.selectedRawMaterials.splice(index, 1);
      console.log("removedRawMaterials :>> ", this.removedRawMaterials);
      this.isValidationError = false;
    },
    decreaseRow_remove_vm: function (index) {
      this.newVendorRateMapping.splice(index, 1);
      this.isValidationError = false;
    },
    increaseRow_add_vm() {
      this.newVendorRateMapping.push({
        cinema_id: null,
        selectedCinema: [],
        cinemaIds: [],
        name: "",
        rm_id: "",
        vr_qty: "",
        uom_id: "",
        uom_unit: "",
        vr_rate: null,
        selectedRawMaterial: "",
        vr_tax_amount: 0,
        vr_tax_amount_percentage: 0,
        vr_total_amount: null,
        vr_is_active: true,
        uom_units: [],
      });
    },
    increaseRow: function () {
      this.selectedRawMaterials.push({
        name: "",
        rm_id: "",
        vr_qty: "",
        uom_id: "",
        uom_unit: "",
        vr_rate: null,
        selectedRawMaterial: "",
        vr_tax_amount: 0,
        vr_tax_amount_percentage: 0,
        vr_total_amount: null,
        vr_is_active: true,
        uom_units: [],
      });
    },
    onSelectRawMaterial: function (params, index, type) {
      if (type == "Add") {
        this.newVendorRateMapping[index].name = params.rm_name;
        this.newVendorRateMapping[index].rm_id = params.rm_id;
        this.newVendorRateMapping[index].uom_id = "";
        this.newVendorRateMapping[index].uom_unit = "";
        this.getRelatedUom(index, params.rm_id, "Add");
        this.isValidationError = false;
      } else {
        this.selectedRawMaterials[index].name = params.rm_name;
        this.selectedRawMaterials[index].rm_id = params.rm_id;
        this.selectedRawMaterials[index].uom_id = "";
        this.selectedRawMaterials[index].uom_unit = "";
        this.getRelatedUom(index, params.rm_id);
        this.isValidationError = false;
      }
    },
    onSelectRawMaterial_vm: function (params, index) {
      this.newVendorRateMapping[index].name = params.rm_name;
      this.newVendorRateMapping[index].rm_id = params.rm_id;
      this.newVendorRateMapping[index].uom_id = "";
      this.newVendorRateMapping[index].uom_unit = "";
      this.getRelatedUom(index, params.rm_id, "Add");
      this.isValidationError = false;
    },
    getRelatedUom: function (index, rm_id, type) {
      PosFnbService.getUomFromRawMaterial({ rm_id })
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (type == "Add") {
              this.newVendorRateMapping[index].uom_units = data.Records;
            } else {
              this.selectedRawMaterials[index].uom_units = data.Records;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectUnitOfM: function (params, index, type) {
      if (type == "Add") {
        this.newVendorRateMapping[index].uom_id = params.uom_id;
        this.newVendorRateMapping[index].uom_unit = params.uom_unit;
        this.isValidationError = false;
      } else {
        this.selectedRawMaterials[index].uom_id = params.uom_id;
        this.selectedRawMaterials[index].uom_unit = params.uom_unit;
        this.isValidationError = false;
      }
    },
    getRawMaterials: function () {
      let loader = this.$loading.show();
      let payload = {
        tableName: "ms_raw_materials",
        rm_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            loader.hide();
            this.RawMaterials = data.Records;
            this.RawMaterialsCopy = data.Records;
          } else {
            loader.hide();
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          loader.hide();
          this.getMappingDetails();
          // setTimeout(() => loader.hide(), 1100);
        }); //message
    },
    getMappingDetails: function () {
      let loader = this.$loading.show();
      // console.log(this.vendor_filters.cinema_id, "this.vendor_filters.cinema_id")
      if (!this.vendor_filters.cinema_id) {
        loader.hide();
        return this.$toasted.show("Please select cinema to view vendor mapping")
      }
      let payload = {
        vendor_id: this.vendor_id,
        cinema_id: this.vendor_filters.cinema_id,
        limit: this.vendor_filters.perPage,
        currentPage: this.vendor_filters.currentPage,
        searchValue: this.vendor_filters.searchValue,
        orderBy: this.vendor_filters.orderBy,
        columnName: this.vendor_filters.columnName,
      };
      this.selectedRawMaterials = [];
      PosFnbService.GetVendorMappingDetails(payload)
        .then((response) => {
          const { data } = response;
          if (
            data.hasOwnProperty("totalCount") &&
            (data.totalCount || data.totalCount == 0)
          ) {
            this.vendor_filters.rows = data.totalCount;
          }
          if (data && data.status && data.Records.length > 0) {
            console.log("data.Records :", data.Records);
            // this.Cinemas = data.Records;
            let obj = data.Records[0];
            // console.log("obj :", obj);
            this.rmv_is_active = obj.rmv_is_active == "Y" ? true : false;
            this.rmv_is_default_vendor =
              obj.rmv_is_default_vendor == "Y" ? true : false;
            this.vendor_id = obj.vendor_id;
            this.cinema_id = obj.cinema_id;
            // console.log("cinema_id :", this.cinema_id);
            this.selectedRawMaterials = [];
            // this.getVendorsList(obj.vendor_id);
            data.Records.forEach((x) => {
              this.rmv_id = x.rmv_id;
              let array = this.RawMaterials.filter(
                (y) => y.rm_id === x.rawmaterial_id
              );
              if (array.length > 0) {
                let obj = {
                  cinema_name: x.cinema_name,
                  cinema_id: x.cinema_id,
                  name: array[0].rm_name,
                  rm_id: array[0].rm_id,
                  rmv_id: x.rmv_id,
                  vr_id: x.vr_id,
                  vr_qty: x.vr_qty,
                  vr_tax_amount: parseFloat(x.vr_tax_amount).toFixed(4),
                  vr_tax_amount_percentage: +parseFloat(
                    (x.vr_tax_amount * 100) / x.vr_rate
                  ).toFixed(4),
                  vr_total_amount: parseFloat(x.vr_total_amount).toFixed(4),
                  vr_rate: parseFloat(x.vr_rate).toFixed(4),
                  vr_is_active: true,
                  uom_id: x.uom_id,
                  uom_unit: x.uom_unit,
                  uom_units: [],
                  selectedRawMaterial: array[0],
                  created_at: x.created_at,
                  is_active: x.rmv_is_active,
                };
                this.selectedRawMaterials.push(obj);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          loader.hide();
          this.cinemas = removeDuplicates(this.cinemas, "cine_id");
          this.$forceUpdate();
        }); //message
    },
    groupedCinemaWiseRawMaterial(records = []) {
      if (records.length > 0) {
        let groupedRM = _.groupBy(records, "cinema_id");
        let groupedArray = Object.values(groupedRM)[0];
        if (groupedArray && groupedArray.length > 0) {
          this.selectedRawMaterials = [];
          groupedArray.forEach((x) => {
            this.rmv_id = x.rmv_id;
            let array = this.RawMaterials.filter(
              (y) => y.rm_id === x.rawmaterial_id
            );
            if (array.length > 0) {
              let obj = {
                name: array[0].rm_name,
                rm_id: array[0].rm_id,
                rmv_id: x.rmv_id,
                vr_id: x.vr_id,
                vr_qty: x.vr_qty,
                vr_tax_amount: x.vr_tax_amount,
                vr_tax_amount_percentage: +parseFloat(
                  (x.vr_tax_amount * 100) / x.vr_rate
                ).toFixed(4),
                vr_total_amount: x.vr_total_amount,
                vr_rate: x.vr_rate,
                vr_is_active: true,
                uom_id: x.uom_id,
                uom_unit: x.uom_unit,
                uom_units: [],
                selectedRawMaterial: array[0],
              };
              this.selectedRawMaterials.push(obj);
            }
          });
        }
      }
    },
    onSelectCinema: function (params) {
      this.selectedCinema = params.cine_name;
      this.cinema_id = params.cine_id;
    },
    setCinemas: function (payload) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      //   // cine_id: cinema_id
      // };
      MasterService.GetCinemas({ cine_id: payload.cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (x.cine_id == payload.cinema_id) {
                // this.selectedCinema = x.cine_name;
                x["rmv_id"] = payload.rmv_id;
                this.cinemas.push(x);
                this.cinemas = removeDuplicates(this.cinemas, "cine_id");
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemasList: function (cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.onSelectCinemaFilter(data.Records[0])
            // this.Cinemas.map(x => {
            //   if (String(cine_id) === String(x.cine_id)) {
            //     // this.selectedCinema = x.cine_name;
            //     // this.onSelectCinema(x.cine_id, x.cine_name);
            //     this.cinemas.push(x)
            //   }
            // });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getunitsofmeasurementsSingle: function (uom_id, obj) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
        uom_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.selectedRawMaterials.push({
              ...obj,
              uom_unit: data.Records[0].uom_unit,
            });
            this.selectedRawMaterials = removeDuplicates(
              this.selectedRawMaterials,
              "rm_id"
            );
            this.selectedRawMaterials.map((x, index) => {
              this.getRelatedUom(index, x.rm_id);
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getunitsofmeasurements: function () {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onChangeRate: function (e, index, type) {
      if (type == "Add") {
        this.newVendorRateMapping[index].vr_total_amount =
          this.newVendorRateMapping[index].vr_total_amount != ""
            ? this.newVendorRateMapping[index].vr_total_amount
            : 0;
        ``;

        this.newVendorRateMapping[index].vr_tax_amount =
          parseFloat(
            this.newVendorRateMapping[index].vr_tax_amount_percentage *
            e.target.value
          ) / 100;

        this.newVendorRateMapping[index].vr_total_amount =
          parseFloat(e.target.value) +
          parseFloat(this.newVendorRateMapping[index].vr_tax_amount || 0);
      } else if (type == "Edit") {
        this.selected_vm.vr_total_amount =
          this.selected_vm.vr_total_amount != ""
            ? this.selected_vm.vr_total_amount
            : 0;
        ``;

        this.selected_vm.vr_tax_amount =
          parseFloat(
            this.selected_vm.vr_tax_amount_percentage * e.target.value
          ) / 100;

        this.selected_vm.vr_total_amount =
          parseFloat(e.target.value) +
          parseFloat(this.selected_vm.vr_tax_amount || 0);
      } else {
        this.selectedRawMaterials[index].vr_total_amount =
          this.selectedRawMaterials[index].vr_total_amount != ""
            ? this.selectedRawMaterials[index].vr_total_amount
            : 0;
        ``;

        this.selectedRawMaterials[index].vr_tax_amount =
          parseFloat(
            this.selectedRawMaterials[index].vr_tax_amount_percentage *
            e.target.value
          ) / 100;

        this.selectedRawMaterials[index].vr_total_amount =
          parseFloat(e.target.value) +
          parseFloat(this.selectedRawMaterials[index].vr_tax_amount || 0);
      }
    },
    onChangeTax: function (e, index, type) {
      if (type == "Add") {
        this.newVendorRateMapping[index].vr_rate =
          this.newVendorRateMapping[index].vr_rate != ""
            ? this.newVendorRateMapping[index].vr_rate
            : 0;
        this.newVendorRateMapping[index].vr_total_amount =
          parseFloat(e.target.value) +
          parseFloat(this.newVendorRateMapping[index].vr_rate);
      } else if (type == "Edit") {
        this.selected_vm.vr_rate =
          this.selected_vm.vr_rate != "" ? this.selected_vm.vr_rate : 0;
        this.selected_vm.vr_total_amount =
          parseFloat(e.target.value) + parseFloat(this.selected_vm.vr_rate);
      } else {
        this.selectedRawMaterials[index].vr_rate =
          this.selectedRawMaterials[index].vr_rate != ""
            ? this.selectedRawMaterials[index].vr_rate
            : 0;
        this.selectedRawMaterials[index].vr_total_amount =
          parseFloat(e.target.value) +
          parseFloat(this.selectedRawMaterials[index].vr_rate);
      }
    },
    onChangeTaxPercentage: function (e, index, type) {
      if (type == "Add") {
        this.newVendorRateMapping[index].vr_rate =
          this.newVendorRateMapping[index].vr_rate != ""
            ? this.newVendorRateMapping[index].vr_rate
            : 0;

        this.newVendorRateMapping[index].vr_tax_amount =
          parseFloat(
            this.newVendorRateMapping[index].vr_rate * e.target.value
          ) / 100;

        this.newVendorRateMapping[index].vr_total_amount =
          parseFloat(this.newVendorRateMapping[index].vr_tax_amount) +
          parseFloat(this.newVendorRateMapping[index].vr_rate);
      } else if (type == "Edit") {
        this.selected_vm.vr_rate =
          this.selected_vm.vr_rate != "" ? this.selected_vm.vr_rate : 0;

        this.selected_vm.vr_tax_amount =
          parseFloat(this.selected_vm.vr_rate * e.target.value) / 100;

        this.selected_vm.vr_total_amount =
          parseFloat(this.selected_vm.vr_tax_amount) +
          parseFloat(this.selected_vm.vr_rate);
      } else {
        this.selectedRawMaterials[index].vr_rate =
          this.selectedRawMaterials[index].vr_rate != ""
            ? this.selectedRawMaterials[index].vr_rate
            : 0;

        this.selectedRawMaterials[index].vr_tax_amount =
          parseFloat(
            this.selectedRawMaterials[index].vr_rate * e.target.value
          ) / 100;

        this.selectedRawMaterials[index].vr_total_amount =
          parseFloat(this.selectedRawMaterials[index].vr_tax_amount) +
          parseFloat(this.selectedRawMaterials[index].vr_rate);
      }
    },
    //Vendor Mapping Ends
    getVendorDetails: function () {
      let payload = {
        tableName: "ms_vendors",
        v_id: this.vendor_details.v_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.vendor_details = obj;

            if (obj.v_extra_contact && obj.v_extra_contact.length) {
              this.v_extra_contacts = obj.v_extra_contact
                .split(",")
                .filter((x) => !!x)
                .map((x) => {
                  let c = x.split("-");
                  return {
                    country_mob_code: c[0],
                    v_contact: c[1],
                    error: false,
                    error_message: "",
                  };
                });
            }
            console.log(
              "this.vendor_details.v_is_active  :",
              this.vendor_details.v_is_active
            );
            this.vendor_details.v_is_active =
              this.vendor_details.v_is_active == "Y" ? true : false;
            this.getCountriesList(obj.country_id || null);
            this.getStatesList(obj.country_id || null, obj.state_id || null);
            this.getCitiesList(obj.state_id || null, obj.city_id || null);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectHandler: function (type, value) {
      if (type == "country") {
        this.selected.Country = value.country_name;
        this.vendor_details.country_id = value.country_id;
        this.selected_state = null;
        this.selected_city = null;
        this.getStatesList(value.country_id);
        this.vendor_details.country_mob_code = value.country_mob_code;
      } else if (type == "state") {
        this.selected.State = value.state_name;
        this.vendor_details.state_id = value.state_id;
        this.selected_city = null;

        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        this.selected.City = value.city_name;
        this.vendor_details.city_id = value.city_id;
      } else if (type == "countrycode") {
        this.vendor_details.country_mob_code = value.country_mob_code;
      }
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    getCountriesList: function (country_id) {
      console.log("country_id :", country_id);
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            data.Records.forEach((record) => {
              delete record.created_at;
              delete record.created_by;
              delete record.updated_at;
              delete record.updated_by;
              delete record.country_is_active;
              delete record.iso_2;
              delete record.iso_3;
              delete record.country_code;
            });

            // this.Countries = data.Records;
            this.Countries = data.Records.sort((a, b) => {
              return a.country_name.localeCompare(b.country_name);
            });
            this.countryList = data.Records;
            this.CodeListCopy = data.Records;
            if (country_id) {
              this.Countries.map((x) => {
                if (country_id === x.country_id) {
                  this.selected.Country = x.country_name;
                  this.selected_country = { country_name: x.country_name };
                }
              });
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getStatesList: function (country_id, state_id) {
      console.log("country_id, state_id :", country_id, state_id);
      this.States = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.StatesMethod,
        params: { id: "country_id-" + country_id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // this.States = data.Records;
            this.States = data.Records.sort((a, b) => {
              return a.state_name.localeCompare(b.state_name);
            });
            this.Cities = [];
            if (state_id) {
              this.States.map((x) => {
                if (state_id === x.state_id) {
                  this.selected.State = x.state_name;
                  this.selected_state = { state_name: x.state_name };
                }
              });
            }
          } else {
            // Show Errors
            this.States = [];
            this.Cities = [];
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCitiesList: function (state_id, city_id) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.CitiesMethod,
        params: { id: "state_id-" + state_id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // this.Cities = data.Records;
            this.Cities = data.Records.sort((a, b) => {
              return a.city_name.localeCompare(b.city_name);
            });
            if (city_id) {
              this.Cities.map((x) => {
                if (city_id === x.city_id) {
                  this.selected.City = x.city_name;
                  this.selected_city = { city_name: x.city_name };
                }
              });
            }
          } else {
            // Show Errors
            this.Cities = [];
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onResetForm: function () {
      this.extraEmailError = false;
      this.cinemas = [];
      // this.selected = {
      //   Country: "",
      //   State: "",
      //   City: "",
      // };
      this.selected_country = null;
      this.selected_city = null;
      this.selected_state = null;
      this.selectedRawMaterials = [
        {
          name: "",
          rm_id: "",
          vr_qty: "",
          uom_id: "",
          uom_unit: "",
          vr_rate: "",
          selectedRawMaterial: "",
          vr_is_active: true,
        },
      ];
      this.selectedRawMaterial = "";
      this.vendor_details = {
        v_name: "",
        v_tin_number: "",
        v_tax_number: "",
        v_tax_type: "",
        v_address: "",
        city_id: "",
        state_id: "",
        country_id: "",
        v_contact: "",
        v_email: "",
        v_extra_emails: "",
        v_location: "",
        v_is_active: true,
      };
    },
    VendorRateValidation: function () {
      let count = 0;

      this.selectedRawMaterials.map((x) => {
        if (x.rm_id == null || x.uom_id == null || !x.rm_id || !x.uom_id) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function () {
      this.extraEmailError = false;
      this.v_extra_contacts.forEach((x) => {
        x.error = false;
        x.error_message = "";
      });

      this.submitted = true;
      this.isValidationError = true;
      let checkRawMaterialExist = true;
      if (this.VendorRateValidation()) {
        console.log("here true");
        // checkRawMaterialExist = false;
        checkRawMaterialExist = true;
        // this.isValidationError = true;
        // return;
      } else {
        checkRawMaterialExist = true;
        console.log("here false");
        this.isValidationError = false;
      }

        const vendorExists = this.filteredVendors.some((el) => {
    console.log("el", el);
    return this.vendor_details.v_name === el.v_name;
  });

  if (vendorExists) {
    this.$toasted.show("Vendor Name Already Present");
    return; 
  }
        

      if (
        this.vendor_details.v_extra_emails &&
        this.vendor_details.v_extra_emails.length > 0
      ) {
        let validEmail = true;

        let emails = [
          ...new Set(
            this.vendor_details.v_extra_emails
              .replace(/\s/g, "")
              .split(",")
              .map((x) => x.trim())
              .filter((x) => !!x)
          ),
        ];

        const regex =
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        for (let i = 0; i < emails.length; i++) {
          if (emails[i] == "" || !regex.test(emails[i])) {
            validEmail = false;
          }
        }

        if (validEmail) {
          this.vendor_details.v_extra_emails = emails.join(",");
        } else {
          this.extraEmailError = true;
          return;
        }
      }
      if (this.v_extra_contacts && this.v_extra_contacts.length) {
        let validContact = true;
        this.v_extra_contacts.forEach((c) => {
          if (!c.country_mob_code || !c.v_contact) {
            c.error = true;
            validContact = false;
          }
          if (!c.country_mob_code) {
            c.error_message = `${c.error_message} Country Code is Required`;
          }
          if (!c.v_contact) {
            c.error_message = `${c.error_message} Please enter Contact Number`;
          } else if (c.v_contact.length <= 5) {
            c.error = true;
            validContact = false;
            c.error_message = `${c.error_message} Please enter minimum 6 characters`;
          }
        });    

        if (validContact) {
          this.vendor_details.v_extra_contact = this.v_extra_contacts
            .map((x) => {
              return `${String(x.country_mob_code).trim()}-${String(
                x.v_contact
              ).trim()}`;
            })
            .join(",");
        } else {
          return;
        }
      } else if (this.v_extra_contacts && this.v_extra_contacts.length === 0) {
        this.vendor_details.v_extra_contact = "";
      }

      this.$validator.validate().then((valid) => {
        if (
          this.vendor_details.country_id == null ||
          this.vendor_details.state_id == null ||
          this.vendor_details.city_id == null ||
          !this.vendor_details.country_mob_code
        ) {
          return;
        }
        if (valid) {
          let loader = this.$loading.show();
          let payload = {
            ...this.vendor_details,
          };
          PosFnbService.UpdateVendor(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                if (checkRawMaterialExist) {
                  this.updateVendorMapping();
                } else {
                  this.$toasted.show("Vendor Updated Successfully");
                  this.$router.push({
                    path: "vendors",
                  });
                }

                // this.onResetForm();
                // this.$toasted.show(data.message);
                // this.$router.push({
                //   path: "vendors"
                // });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((e) => {
              loader.hide();
              this._CatchError(e);
            })
            .finally(() => {
              loader.hide();
            });
        }
      });
    },
    updateVendorMapping() {
      let loader = this.$loading.show();
      let payload = {
        cinemas: this.cinemas,
        removedCinemas: this.removedCinemas,
        vendor_id: this.vendor_id,
        rmv_id: this.rmv_id,
        rmv_is_default_vendor: this.rmv_is_default_vendor == true ? "Y" : "N",
        rmv_is_active: this.rmv_is_active == true ? "Y" : "N",
        selectedRawMaterials: this.selectedRawMaterials,
        removedRawMaterials: this.removedRawMaterials,
        finalAddVendorMappingArray: this.finalAddVendorMappingArray,
        finalEditVendorMappingArray: this.finalEditVendorMappingArray,
      };
      console.log("payload :", payload);
      PosFnbService.UpdateVendorMapping(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.onResetForm();
            this.$toasted.show(data.message);
            this.$router.push({
              path: "vendors",
            });
            // this.$router.push({
            //   path: "vendor-mapping"
            // });
            //this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          loader.hide();
        });
    },
    updateVendorMappingOld: async function () {
      const distinctCinemas = [...new Set([...this.selectedRawMaterials, ...this.finalEditVendorMappingArray].map(selectedRawMaterialObj => {
        return selectedRawMaterialObj.cinema_id
      }))]
      console.log({ distinctCinemas })
      if (!distinctCinemas.length) return this.$toasted.show("No cinemas found")

      const groupedPayloads = {}
      distinctCinemas.forEach(distinctCinemasObj => {
        groupedPayloads[distinctCinemasObj] = {
          cinemas: this.cinemas,
          removedCinemas: this.removedCinemas,
          vendor_id: this.vendor_id,
          rmv_id: this.rmv_id,
          rmv_is_default_vendor: this.rmv_is_default_vendor == true ? "Y" : "N",
          rmv_is_active: this.rmv_is_active == true ? "Y" : "N",
          selectedRawMaterials: this.selectedRawMaterials.filter(selectedRawMaterialObj => {
            return selectedRawMaterialObj.cinema_id == distinctCinemasObj
          }),
          removedRawMaterials: this.removedRawMaterials,
          finalAddVendorMappingArray: this.finalAddVendorMappingArray.filter(addMappingObj => {
            return addMappingObj.cinema_id == distinctCinemasObj
          }),
          finalEditVendorMappingArray: this.finalEditVendorMappingArray.filter(editMappingObj => {
            return editMappingObj.cinema_id == distinctCinemasObj
          }),
        };
      })
      console.log({ groupedPayloads })
      const promises = Object.keys(groupedPayloads).map(promiseObj => {
        return new Promise(async (resolve, reject) => {
          try {
            const response = await PosFnbService.UpdateVendorMapping(groupedPayloads[promiseObj])

            resolve()
          } catch (error) {
            console.log(error)
            reject(`Updation failed for ${promisesObj}`)
          }
        })
      })

      await Promise.all(promises)
      this.$router.push({
        path: "vendors",
      });
      // const groupedPayload=this

    }
  },
};
</script>

<style>
.sectionName {
  padding: 5px 0px;
  color: #4a87e1;
}

.sectionName .fs-17 {
  font-size: 17px !important;
}

.text-small-instruction {
  font-weight: 400;
}

.text-red {
  color: red;
}

.disable-field {
  cursor: not-allowed;
  opacity: 0.5;
}

.bor {
  border: 1px solid #b1b4b8;
  border-radius: 10px;
}

.back {
  background-color: #f5f5f5;
}

.inner-vendor-rate {
  background-color: #fff;
  border: 1px solid #b1b4b8;
  border-radius: 10px;
}

.strikeout td {
  position: relative;
}

.strikeout {
  opacity: 0.5;
  pointer-events: none;
}

tr.strikeout td:before {
  content: " ";
  position: absolute;
  top: 50%;
  left: 0;
  border-bottom: 1px solid red;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/VendorsComponents/editVendor.vue